import React, { useEffect } from 'react';
import { CardWithFadeInScale } from 'modules/ai/ui/Card.styles';
import {
  StyledRadioListItem,
  StyledRadio,
} from 'modules/ai/nba/components/selectionListWithRadio/SelectionRadioListItem.styles';

interface SelectionRadioListItemProps {
  id: string;
  setSelectedValue: (selection: string) => void;
  selectedValue: string;
  isRadioSelectionEnabled: boolean;
  children?: React.ReactNode;
}

export const SelectionRadioListItem = React.forwardRef(
  (
    {
      id,
      setSelectedValue,
      selectedValue,
      isRadioSelectionEnabled,
      children,
    }: SelectionRadioListItemProps,
    ref: any,
  ) => {
    useEffect(() => {
      if (ref && ref?.current && isRadioSelectionEnabled) {
        ref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }
    }, [isRadioSelectionEnabled]);

    const onClickRadioInput = () => {
      setSelectedValue(id.toString());
    };

    const isSelected = id.toString() === selectedValue;

    return (
      <CardWithFadeInScale ref={ref} data-selected={isSelected} onClick={onClickRadioInput}>
        <StyledRadioListItem id="list-item">
          {children}
          {isRadioSelectionEnabled && (
            <StyledRadio
              value={id}
              isChecked={isSelected}
              onClick={onClickRadioInput}
              id={`radio-list-item-${id}`}
            />
          )}
        </StyledRadioListItem>
      </CardWithFadeInScale>
    );
  },
);
